import { useEffect, useState } from 'react'
import ExtAgApis from '../api'

const useFetchData = (copro_id, coproprietaire_id) => {
  const apiExtAgs = new ExtAgApis()
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const fetchData = async () => {
    try {
      setIsLoading(true)
      const res = await apiExtAgs.getExtAgs()
      setData(res)
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.error(error)
    }
  }

  useEffect(() => {
    window.context['context-extagdialog-coproid'] = copro_id
    window.context['context-extagdialog-coproprietaireid'] = coproprietaire_id
    fetchData()
  }, [copro_id, coproprietaire_id])

  return { data, isLoading }
}

export default useFetchData
